import React from "react";
import {connect} from "react-redux";
import {DragDropContext, Droppable} from "react-beautiful-dnd";

// @mui/material components
import {makeStyles} from "@mui/styles";

// core components
import Gender from './gender';

// action
import { updatePosition } from "actions/gender/updatePosition";

// styles
const useStyles = makeStyles(theme => ({
    boxesList: {
        position: "relative",
        background: "green !important"
    },
    removeStyleType: {
        listStyleType: "none",
    },
    removePadding :{
        listStyleType: "none",
        paddingInlineStart: "0px",
        '&  li': {
            position: 'relative',
        },
        '&  li:hover': {
            overflow: 'visible',
        },
    },
}));

function Boxes (props) {
    const { allGenders, search, updatePosition } = props;

    const classes = useStyles();

    function reorder(list, startIndex, endIndex) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        if (result.destination.index === result.source.index) {
            return;
        }

        const genders = reorder(
            allGenders,
            result.source.index,
            result.destination.index
        );

        // assignPositionToGender
        let formattedGenders = [];

        genders.forEach((gender, index) => {
            let item = {
                "id": gender.id,
                "position": index + 1
            };

            formattedGenders.push(item);
        });

        updatePosition({"genders": formattedGenders});
    }

    return (
        <DragDropContext onDragEnd={onDragEnd} className={classes.boxesList}>
            <Droppable droppableId={"list"}>
                {provided => (
                    <ul className={classes.removePadding}>
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {allGenders.map((gender, index) => {
                                if (search.length > 0 ? gender : true) {
                                    return (
                                        <Gender
                                            key={gender.id}
                                            data={gender}
                                            provided={provided}
                                            draggableId={gender.id}
                                            index={index}
                                            {...props}
                                        />
                                    )
                                } else return null;
                            })}
                        </div>
                        {provided.placeholder}
                    </ul>
                )}
            </Droppable>
        </DragDropContext>
    )
}

const mapStateToProps = (state) => {
    return {
        created: state.gender.create.created,
        deleted: state.gender.deleteGender.deleted,
        updated: state.gender.update.updated,
    };
};

const mapDispatchToProps = dispatch => ({
    updatePosition: (params) => dispatch(updatePosition(params)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Boxes);
